<template>
	<div class="outer-page">
		<div v-if="page"
			 ref="innerPage"
			 class="inner-page">
			<main>
				<DirectusBlocks v-for="block in page.blocks"
								:key="block.id"
								:data="block" />

				<!-- <br><br> -->
				<!-- DIRECTUS TODO: rename appropriately -->
				<!-- <flexibleCalltoaction class="cta-bottom" /> -->
			</main>
		</div>
		<div v-else>
			<div class="inner-page">
				<main>
					Loading ...
				</main>
			</div>
		</div>
	</div>
</template>

<script setup>
const { directus, readItems } = useDirectus()
const { $bus } = useNuxtApp()
const metaStore = useMetaStore()
const config = useRuntimeConfig()
const route = useRoute()
const previewStatus = computed(() => route.query.status || 'published')
const slug = computed(() => route.name)
const url = route.fullPath

const { data: pageData } = await useAsyncData(`${url}`, () => {
	return directus.request(readItems('pages', pageQuery(slug.value, previewStatus.value)))
})

// removed unused works fetch to silence lint warnings

const page = computed(() => {
	if (!pageData.value.length) showError({ statusCode: 404, statusMessage: 'Page Not Found' })
	return pageData.value[0]
})

// const allWorks = computed(() => worksData.value || null) // unused - keep here for future use if needed


useSuperSeoMeta(page.value, { ...config, url })

const innerPage = ref(null)

function initComponent() {
	metaStore.setActivePageColors(page.value)

	$bus.$emit('header-change-color', { primary: '#121212', secondary: '#fdfdfd' })
	$bus.$emit('page-mounted')
}

onMounted(() => {
	useAnims(initComponent)
	useCssAnims(innerPage.value)
})
</script>

<style lang="scss" scoped>
:deep(.flex-module:first-of-type) {
	margin-top: calc(rem-calc(180) - 111px);

	@include for-devices-above(md) {
		margin-top: calc(rem-calc(240) - 138px);
	}

	@include for-devices-above(xl) {
		margin-top: calc(rem-calc(400) - 150px);
	}

	&.flexible-herotext {
		position: relative;
		margin-top: 0;
		margin-bottom: 0;
		padding-top: calc(12vmin - 1em);
		padding-bottom: 10vh;

		@include for-devices-above(lg) {
			padding-top: calc(15vmin - 1em);
			padding-bottom: 16vmin;
		}

		.hero-title {
			transform: translateY(calc(-50% + 1em));
		}
	}
}

.request-full-portfolio {
	align-content: flex-end;
	text-align: right;
	@include universal-side-padding;
	overflow-x: hidden;
	margin-top: rem-calc(-100) * 0.5;

	@include for-devices-above(md) {
		margin-top: rem-calc(-140)* 0.5;
	}

	@include for-devices-above(xl) {
		margin-top: rem-calc(-200)* 0.5;
	}

	.button-safe-wrap {
		margin-top: calc((3rem * 1));
		margin-bottom: calc((3rem * 1));
	}
}



:deep(.flex-module:first-of-type.flexible-herotext + .flex-module) {
	margin-top: 0;
}

.request-full-portfolio {
	@include standard-margin-bottom;
}
</style>